<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="open-sans-30pt">
          Nastavitve portala
          <span style="display: inline-block">
            Moj T-2
          </span>
        </p>
        <div style="padding-top: 20px">
          <p>
            Tukaj lahko nastavite svojo naročnino in priključek, s katerim lahko spremljate tv2go, pregled porabe
            vaše mobilne številke<br> in pregled podatkov tistih priključkov, ki jih želite privzeto uporabljati.
            Označeni priključki se bodo samodejno prikazali ob vsaki prijavi v
            Moj T-2 in jih lahko kadarkoli kasneje uredite.
          </p>
          <p>
            V primeru, da imate v portalu povezano le eno naročnino in/ali en mobilni priključek, vam ni potrebno
            nastavljati privzetih priključkov.
          </p>
        </div>
        <div v-if="seznamNarocnin.length > 0">
          <div style="padding-top: 30px">
            <p class="open-sans-20pt">
              Moje naročnine
            </p>
          </div>
          <div class="odmik-top-30">
            Izberite privzeto naročnino, ki želite, da bo izbrana ob vsakokratni prijavi v portal.
          </div>
          <el-table :data="seznamNarocnin" class="hidden-xs"
                    empty-text="Nimate povezanih naročnin" v-loading="nalaganje"
                    style="padding-top: 20px">
            <el-table-column prop="id_stranka" label="Št. stranke"/>
            <el-table-column prop="naziv" label="Naročnik"/>
            <el-table-column label="Naslov naročnika">
              <template slot-scope="scope">
                {{ scope.row.naslov }}
                <br/>
                {{ scope.row.kraj }}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-checkbox-group :value="seznamPrivzetihNarocnin">
                  <el-checkbox :key="scope.row.id_stranka_sap" :label="scope.row.id_stranka_sap"
                    @change="IzberiEnoVrednostCheckboxListe(seznamPrivzetihNarocnin, scope.row.id_stranka_sap, true)"
                    v-if="scope.row.id_stranka_sap === shranjenPrivzetSap">
                    <b>Privzeto</b>
                  </el-checkbox>
                  <el-checkbox :key="scope.row.id_stranka_sap" :label="scope.row.id_stranka_sap"
                               @change="IzberiEnoVrednostCheckboxListe
                               (seznamPrivzetihNarocnin, scope.row.id_stranka_sap, true)"
                               v-else>
                    Nastavi za privzeto
                  </el-checkbox>
                </el-checkbox-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <InfoKomponentaNastavitveMojT2NiNarocnin/>
        </div>
        <div class="visible-xs-block">
          <div style="padding-top: 20px" v-if="prikazTabele === '1'">
            <el-table :data="seznamNarocnin"
                      :expand-row-keys="expandRowKeys"
                      :row-key="row => row.id_stranka"
                      empty-text="Nimate povezanih naročnin" v-loading="nalaganje"
                      @expand-change="IzbiraVrsticeZaPrikazPodatkov">
              <el-table-column prop="id_stranka" label="ŠT. STRANKE"/>
              <el-table-column prop="naziv" label="NAROČNIK"/>
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div style="padding-top: 20px; padding-bottom: 20px">
                    <div>
                      <p>
                        Naslov naročnika: {{ scope.row.naslov }}
                      </p>
                    </div>
                    <div>
                      <el-checkbox-group :value="seznamPrivzetihNarocnin">
                        <el-checkbox :key="scope.row.id_stranka_sap" :label="scope.row.id_stranka_sap"
                                     @change="IzberiEnoVrednostCheckboxListe
                                     (seznamPrivzetihNarocnin, scope.row.id_stranka_sap, true)"
                                     v-if="scope.row.id_stranka_sap === shranjenPrivzetSap">
                          <b>Privzeto</b>
                        </el-checkbox>
                        <el-checkbox :key="scope.row.id_stranka_sap" :label="scope.row.id_stranka_sap"
                                     @change="IzberiEnoVrednostCheckboxListe
                                     (seznamPrivzetihNarocnin, scope.row.id_stranka_sap, true)"
                                     v-else>
                          Nastavi za privzeto
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <el-table :data="seznamNarocnin"
                      :row-key="row => row.id_stranka"
                      empty-text="Nimate povezanih naročnin" v-loading="nalaganje">
              <el-table-column>
                <template slot-scope="props">
                  <p style="padding-top: 10px;">
                    <span>
                      <b>
                        Številka stranke:
                      </b>
                    </span>
                    {{ props.row.id_stranka_sap }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Naročnik:
                      </b>
                    </span>
                    {{ props.row.naziv }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Naslov naročnika:
                      </b>
                    </span>
                    {{ props.row.naslov }} {{ props.row.kraj }}
                  </p>
                  <div>
                    <el-checkbox-group :value="seznamPrivzetihNarocnin">
                      <el-checkbox :key="props.row.id_stranka_sap" :label="props.row.id_stranka_sap"
                                   @change="IzberiEnoVrednostCheckboxListe
                                     (seznamPrivzetihNarocnin, props.row.id_stranka_sap, true)"
                                   v-if="props.row.id_stranka_sap === shranjenPrivzetSap">
                        <b>Privzeto</b>
                      </el-checkbox>
                      <el-checkbox :key="props.row.id_stranka_sap" :label="props.row.id_stranka_sap"
                                   @change="IzberiEnoVrednostCheckboxListe
                                     (seznamPrivzetihNarocnin, props.row.id_stranka_sap, true)"
                                   v-else>
                        Nastavi za privzeto
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="odmik-top-20" style="padding-top: 40px">
          <hr class="hr-stil">
        </div>
        <div style="padding-top: 50px"/>
        <div>
          <p class="open-sans-20pt">
            Moji priključki
          </p>
          <div class="odmik-top-30">
            <p class="navadno-besedilo">
              Izberite privzeti priključek, s katerim boste spremljali tv2go ter označite mobilno številko za
              spremljanje porabe in upravljanje nastavitev.
            </p>
          </div>
          <div class="odmik-top-30" v-loading="nalaganjePrikljuckov">
            <div>
              <p class="navadno-besedilo">
                <b>Izberite privzeti priključek za ogled mobilne televizije tv2go</b>
              </p>
              <div v-if="seznamPrikljuckovTv2go2.length > 0">
                <table cellspacing="0" cellpadding="0" border="0">
                  <tr v-for="prikljucek in seznamPrikljuckovTv2go2">
                    <td style="padding-top: 10px;">
                      <el-checkbox-group :value="seznamPrivzetihPrikljuckovTv2go">
                        <el-checkbox
                          class="privzeti-prikljucek"
                          :key="prikljucek.id_prikljucek" :label="prikljucek.id_prikljucek"
                          @change="IzberiEnoVrednostCheckboxListe(seznamPrivzetihPrikljuckovTv2go, prikljucek.id_prikljucek, false)">
                          ID {{prikljucek.id_prikljucek}} - {{prikljucek.naslov}}, {{prikljucek.kraj}}
                          <span v-if="prikljucek.tip_prikljucka !== 'FIX'">
                            ({{prikljucek.tip_prikljucka_opisno}})
                          </span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else>
                <div>
                  <p>
                    Nimate priključka za izbiro.
                  </p>
                </div>
              </div>
            </div>
            <div class="odmik-top-40">
              <p class="navadno-besedilo">
                <b>Izberite privzeti priključek za pregled in urejanje stacionarne naročnine</b>
              </p>
              <div v-if="seznamPrikljuckovFix.length > 0">
                <table cellspacing="0" cellpadding="0" border="0">
                  <tr v-for="prikljucek in seznamPrikljuckovFix">
                    <td style="padding-top: 10px;">
                      <el-checkbox-group :value="seznamPrivzetihPrikljuckovFix">
                        <el-checkbox
                          class="privzeti-prikljucek"
                          :key="prikljucek.id_prikljucek" :label="prikljucek.id_prikljucek"
                          @change="IzberiEnoVrednostCheckboxListe
                          (seznamPrivzetihPrikljuckovFix, prikljucek.id_prikljucek, false)">
                          ID {{prikljucek.id_prikljucek}} - {{prikljucek.naslov}}, {{prikljucek.kraj}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else>
                <div>
                  Nimate priključka za izbiro.
                </div>
              </div>
            </div>
            <div class="odmik-top-40">
              <p class="navadno-besedilo">
                <b>Izberite privzeti priključek za pregled porabe in urejanje mobilne naročnine</b>
              </p>
              <div v-if="seznamPrikljuckovUmts.length > 0">
                <table cellspacing="0" cellpadding="0" border="0">
                  <tr v-for="prikljucek in seznamPrikljuckovUmts">
                    <td style="padding-top: 10px;">
                      <el-checkbox-group :value="seznamPrivzetihPrikljuckovUmts">
                        <el-checkbox
                          class="privzeti-prikljucek"
                          :key="prikljucek.id_prikljucek" :label="prikljucek.id_prikljucek"
                          @change="IzberiEnoVrednostCheckboxListe (seznamPrivzetihPrikljuckovUmts, prikljucek.id_prikljucek, false)">
                          {{prikljucek.izpisStevilkeUmts}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else>
                <div>
                  Nimate priključka za izbiro.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="odmik-top-40">
          <p>
            <el-button class="gumb-potrdi" type="primary" @click="ShraniPrivzeteVrednosti">
              SHRANI SPREMEMBE
            </el-button>
          </p>
        </div>
        <div>
          <InfoKomponentaNastavitveMojT2/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {Input, Button, Collapse, CollapseItem, MessageBox, Col, Checkbox, CheckboxGroup} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {StoritevVrstaEnum} from '../../../../assets/js/Enum/StoritevVrstaEnum.js'
import InfoKomponentaNastavitveMojT2 from './NastavitveMojT2/InfoKomponentaNastavitveMojT2'
import {PridobivanjeVklopljenoNaroceno} from '../../../../assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno'
import InfoKomponentaNastavitveMojT2NiNarocnin from './NastavitveMojT2/InfoKomponentaNastavitveMojT2NiNarocnin'
import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {GetPodatkiIzbirnika} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika'
import {PrivzetaVrednostTipEnum} from '../../../../assets/js/Enum/PrivzetaVrednostTipEnum.js'
import MenuAndRoutesBuilder from '../../../../assets/js/menuAndRoutesBuilder'
import {
  FormatirajTelefonskoStevilko
} from '../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke'
import Vue from 'vue'
import PrivzetaVrednostLogic from '../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
import {PrikljucekStatusEnum} from '../../../../assets/js/Enum/PrikljucekStatusEnum'
export default {
  name: 'NastavitveMojT2',
  mixins: [GetPodatkiIzbirnika, PridobiStranko, PrikazVsebine, StoritevVrstaEnum, PridobivanjeVklopljenoNaroceno,
    PrivzetaVrednostTipEnum, FormatirajTelefonskoStevilko],
  data () {
    return {
      clientAgent: null,
      seznamNarocnin: [],
      nalaganje: false,
      nalaganjePrikljuckov: true,
      privzetiPrikljucki: [],
      activeName: '0',
      izbranPrikljucek: null,
      expandRowKeys: [],
      podatkiOPrikljuckih: null,
      seznamPrivzetihNarocnin: [],
      shranjenPrivzetSap: '',
      seznamPrikljuckovFix: [],
      seznamPrivzetihPrikljuckovFix: [],
      seznamPrikljuckovUmts: [],
      seznamPrivzetihPrikljuckovUmts: [],
      seznamPrikljuckovTv2go2: [],
      seznamPrivzetihPrikljuckovTv2go: [],
      menuAndRoutesBuilder: MenuAndRoutesBuilder.getInstance(),
      formatiranjeStevilke: null,
      prikazTabele: '1'
    }
  },
  components: {
    GetPodatkiIzbirnika,
    InfoKomponentaNastavitveMojT2NiNarocnin,
    PridobivanjeVklopljenoNaroceno,
    InfoKomponentaNastavitveMojT2,
    StoritevVrstaEnum,
    PridobiStranko,
    [Button.name]: Button,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Col.name]: Col,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  izbranaStranka: function () {
    if (this.izbranaStranka !== null) {
      this.GetNarocnine()
      this.PosodobiPodatkeStranke()
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetNarocnine()
    this.PosodobiPodatkeStranke()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    IzbiraVrsticeZaPrikazPodatkov (row) {
      const id = row.id_stranka
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    GetPrikljuckiDovoljenja () {
      let params = []
      params.push('permissions[]=PRIKLJUCKI')
      params.push('permissions[]=TV2GO')
      this.clientAgent.postWsRequest(
        this,
        'permissions/all',
        params,
        null,
        'SetPrikljuckiDovoljenja',
        'ErrPrikljuckiDovoljenja')
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovFix = []
      this.seznamPrikljuckovUmts = []
      this.seznamPrikljuckovTv2go2 = []
      this.podatkiOPrikljuckih = podatki
      this.SetSeznamePrikljuckov()
    },
    SetSeznamePrikljuckov () {
      let izbranPrivzetSap = this.seznamPrivzetihNarocnin.length > 0 ? this.seznamPrivzetihNarocnin[0] : null

      // fix
      let seznamZaFixPrikljucke = this.podatkiOPrikljuckih.results.PRIKLJUCKI
      this.seznamPrikljuckovFix = []
      let shranjenPrivzetPrikljucekFix = this.GetShranjenaPrivzetaVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK)
      let shranjenPrivzetaVrednostFixVSeznamu = false
      for (let i = 0; i < seznamZaFixPrikljucke.additionalData.length; i++) {
        if (seznamZaFixPrikljucke.additionalData[i]['tip_prikljucka'] === 'FIX') {
          let prikljucekInfo = seznamZaFixPrikljucke.additionalData[i]
          if (izbranPrivzetSap === null || izbranPrivzetSap === prikljucekInfo['id_stranka_sap']) {
            if (shranjenPrivzetPrikljucekFix !== null && shranjenPrivzetPrikljucekFix === prikljucekInfo.id_prikljucek) {
              shranjenPrivzetaVrednostFixVSeznamu = true
            }
            this.seznamPrikljuckovFix.push(prikljucekInfo)
          }
        }
      }
      if (shranjenPrivzetaVrednostFixVSeznamu) {
        this.IzberiEnoVrednostCheckboxListe(this.seznamPrivzetihPrikljuckovFix, shranjenPrivzetPrikljucekFix, false)
      } else if (this.seznamPrikljuckovFix.length > 0) {
        this.IzberiEnoVrednostCheckboxListe(this.seznamPrivzetihPrikljuckovFix,
          this.seznamPrikljuckovFix[0]['id_prikljucek'].toString(), false)
      }
      // konec fix

      // umts
      let seznamZaUmtsPrikljucke = this.podatkiOPrikljuckih.results.PRIKLJUCKI.additionalData.filter(x =>
        x.idStatus !== PrikljucekStatusEnum.NEOPREDELJEN && x.tip_prikljucka === 'UMTS')

      this.seznamPrikljuckovUmts = []
      let shranjenPrivzetPrikljucekUmts = this.GetShranjenaPrivzetaVrednost(PrivzetaVrednostTipEnum.MOBILNA_ST)
      let shranjenPrivzetaVrednostMobilnaVSeznamu = false
      for (let i = 0; i < seznamZaUmtsPrikljucke.length; i++) {
        let prikljucekInfo = seznamZaUmtsPrikljucke[i]
        let format = this.VrniFormatiranoTelefonsko(prikljucekInfo.umts_stevilka, '5')
        Vue.set(prikljucekInfo, 'izpisStevilkeUmts', format)
        if (izbranPrivzetSap === null || izbranPrivzetSap === prikljucekInfo['id_stranka_sap']) {
          if (shranjenPrivzetPrikljucekUmts !== null && shranjenPrivzetPrikljucekUmts === prikljucekInfo.id_prikljucek) {
            shranjenPrivzetaVrednostMobilnaVSeznamu = true
          }
          this.seznamPrikljuckovUmts.push(prikljucekInfo)
        }
      }
      if (shranjenPrivzetaVrednostMobilnaVSeznamu) {
        this.IzberiEnoVrednostCheckboxListe(this.seznamPrivzetihPrikljuckovUmts, shranjenPrivzetPrikljucekUmts, false)
      } else if (this.seznamPrikljuckovUmts.length > 0) {
        this.IzberiEnoVrednostCheckboxListe(this.seznamPrivzetihPrikljuckovUmts,
          this.seznamPrikljuckovUmts[0]['id_prikljucek'].toString(), false)
      }
      // konec umts

      // tv2go
      let seznamZaTv2GoPrikljucke = this.podatkiOPrikljuckih.results.TV2GO
      this.seznamPrikljuckovTv2go2 = []
      let shranjenPrivzetPrikljucekTv2Go = this.GetShranjenaPrivzetaVrednost(PrivzetaVrednostTipEnum.TV2GO_PRIKLJUCEK)
      let shranjenPrivzetaVrednostTv2GoVSeznamu = false
      if (seznamZaTv2GoPrikljucke.selector !== null) {
        for (let i = 0; i < seznamZaTv2GoPrikljucke.selector.length; i++) {
          let prikljucekInfo2 = seznamZaTv2GoPrikljucke.selector[i]
          let sapObravnavanegaPrikljucka = null
          let prikljucekInfo3 = null
          for (let j = 0; j < seznamZaTv2GoPrikljucke.additionalData.length; j++) {
            if (seznamZaTv2GoPrikljucke.additionalData[j].id_prikljucek === prikljucekInfo2.id) {
              sapObravnavanegaPrikljucka = seznamZaTv2GoPrikljucke.additionalData[j].id_stranka_sap
              prikljucekInfo3 = seznamZaTv2GoPrikljucke.additionalData[j]
              if (izbranPrivzetSap === null ||
                (izbranPrivzetSap === sapObravnavanegaPrikljucka)) {
                if (shranjenPrivzetPrikljucekTv2Go !== null && shranjenPrivzetPrikljucekTv2Go === prikljucekInfo2.id) {
                  shranjenPrivzetaVrednostTv2GoVSeznamu = true
                }
                this.seznamPrikljuckovTv2go2.push(JSON.parse(JSON.stringify(prikljucekInfo3)))
              }
            }
          }
        }
      }
      if (shranjenPrivzetaVrednostTv2GoVSeznamu) {
        this.IzberiEnoVrednostCheckboxListe(this.seznamPrivzetihPrikljuckovTv2go, shranjenPrivzetPrikljucekTv2Go, false)
      } else if (this.seznamPrikljuckovTv2go2.length > 0) {
        this.IzberiEnoVrednostCheckboxListe(this.seznamPrivzetihPrikljuckovTv2go,
          this.seznamPrikljuckovTv2go2[0].id, false)
      }
      // konec tv2go

      this.nalaganjePrikljuckov = false
    },
    GetShranjenaPrivzetaVrednost (tipVrednosti) {
      for (const index in this.privzetiPrikljucki) {
        let indexString = index.toString()
        if (indexString === tipVrednosti.toString()) {
          return this.privzetiPrikljucki[index]
        }
      }
      return null
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetNarocnine () {
      this.GetUserData()
    },
    OdstraniNarocnino (idStrankaSap) {
      MessageBox.confirm('Ali ste prepričani, da želite odstraniti naročnino?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        let param = ['sap=' + idStrankaSap]
        this.clientAgent.postWsRequest(this,
          'subscriptions/remove',
          param,
          null,
          'UspesnoOdstranjenaNarocnina',
          'ErrNastavitevPrivzeteVrednosti')
      })
    },
    PosodobiPodatkeStranke () {
      this.nalaganje = true
      this.nalaganjePrikljuckov = true
      let param = {}
      param.vmesnik = this
      param.callbackFunction = this.PrenosniPodatkiStranke
      this.PridobiPodatkeIzbirnika(param)
    },
    UspesnoOdstranjenaNarocnina () {
      this.activeName = '0'
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno odstranjena naročnina.'
      this.ShowSuccessMessage(paramObvestilo)
      if (this.seznamNarocnin.length > 1) {
        this.PosodobiPodatkeStranke()
        this.GetNarocnine()
      } else {
        window.location.reload()
      }
    },
    ShraniPrivzeteVrednosti () {
      this.nalaganje = true
      this.nalaganjePrikljuckov = true
      let param = []
      if (this.seznamPrivzetihNarocnin.length > 0) {
        param.push('sap=' + this.seznamPrivzetihNarocnin[0])
      }
      if (this.seznamPrivzetihPrikljuckovFix > 0) {
        param.push('fix=' + this.seznamPrivzetihPrikljuckovFix[0])
      }
      if (this.seznamPrivzetihPrikljuckovTv2go > 0) {
        param.push('tv2go=' + this.seznamPrivzetihPrikljuckovTv2go[0])
      }
      if (this.seznamPrivzetihPrikljuckovUmts > 0) {
        param.push('umts=' + this.seznamPrivzetihPrikljuckovUmts[0])
      }
      this.clientAgent.postWsRequest(this,
        'user/updateDefaultSubscriptionValues?',
        param,
        null,
        'GetNastavitevPrivzeteVrednosti',
        'ErrNastavitevPrivzeteVrednosti')
    },
    GetNastavitevPrivzeteVrednosti () {
      this.GetUserData()
      this.PosodobiPodatkeStranke()
    },
    ErrNastavitevPrivzeteVrednosti (err) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Prišlo je do napake: ' + ' ( ' + err.message + ')'
      this.ShowWarningMessage(paramObvestilo)
    },
    PrenosniPodatkiStranka (podatki) {
      if (this.seznamPrivzetihNarocnin.length === 0) {
        this.seznamPrivzetihNarocnin.push(podatki.defaultSubscription)
        PrivzetaVrednostLogic.getInstance().ShraniPrivzetoVrednost(PrivzetaVrednostTipEnum.SAP, podatki.defaultSubscription)
      }
      if (this.seznamPrivzetihNarocnin.length > 0) {
        this.shranjenPrivzetSap = this.seznamPrivzetihNarocnin[0]
      }
      this.privzetiPrikljucki = podatki.defaultConnectors
      for (const index in this.privzetiPrikljucki) {
        let indexString = index.toString()
        let id = this.privzetiPrikljucki[index]
        if (indexString === PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK.toString()) {
          if (!this.seznamPrivzetihPrikljuckovFix.includes(id)) {
            this.seznamPrivzetihPrikljuckovFix.push(this.privzetiPrikljucki[index])
            PrivzetaVrednostLogic.getInstance().ShraniPrivzetoVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK, this.privzetiPrikljucki[index].id)
          }
        } else if (indexString === PrivzetaVrednostTipEnum.TV2GO_PRIKLJUCEK.toString()) {
          if (!this.seznamPrivzetihPrikljuckovTv2go.includes(id)) {
            this.seznamPrivzetihPrikljuckovTv2go.push(this.privzetiPrikljucki[index])
            PrivzetaVrednostLogic.getInstance().ShraniPrivzetoVrednost(PrivzetaVrednostTipEnum.TV2GO_PRIKLJUCEK, this.privzetiPrikljucki[index].id)
          }
        } else if (indexString === PrivzetaVrednostTipEnum.MOBILNA_ST.toString()) {
          if (!this.seznamPrivzetihPrikljuckovUmts.includes(id)) {
            this.seznamPrivzetihPrikljuckovUmts.push(this.privzetiPrikljucki[index])
            PrivzetaVrednostLogic.getInstance().ShraniPrivzetoVrednost(PrivzetaVrednostTipEnum.MOBILNA_ST, this.privzetiPrikljucki[index].id)
          }
        }
      }
      this.GetPrikljuckiDovoljenja()
      this.menuAndRoutesBuilder.RetrieveRoutesAndSideBarLinks()
    },
    PrenosniPodatki (seznam) {
      this.seznamNarocnin = []
      this.seznamNarocnin = seznam.data
      this.nalaganje = false
    },
    IzberiEnoVrednostCheckboxListe (seznam, vrednost, posodobiPodredniSeznam) {
      for (const index2 in seznam) {
        seznam.splice(index2, 1)
      }
      // dvojni izbris, ki dela (ne me vprasat zakaj)
      for (const index2 in seznam) {
        seznam.splice(index2, 1)
      }
      seznam.push(vrednost)
      if (posodobiPodredniSeznam) {
        this.SetSeznamePrikljuckov()
      }
    }
  },
  watch: {
    orientacijaPrikazaTabele (val) {
      this.prikazTabele = val
    }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/narocnine.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/NastavitveMojT2.vue